export const INVENTORY_ITEM_TYPE_ZTE_STICK = 'zteStick';
export const INVENTORY_ITEM_TYPE_RASPBERRY_PI = 'raspberryPi';
export const INVENTORY_ITEM_TYPE_KWIKSET_LOCK = 'kwiksetLock';
export const INVENTORY_ITEM_TYPE_CODEBOX_SUNROOM = 'codeboxSunroom';
export const INVENTORY_ITEM_TYPE_CODEBOX_HOMERIVER = 'codeboxHomeRiver';
export const INVENTORY_ITEM_TYPE_COMBO_LOCKBOX = 'comboLockbox';
export const INVENTORY_ITEM_TYPE_SUPRA = 'supra';
export const INVENTORY_ITEM_TYPE_YARDSIGN_FRAME = 'yardSignFrame';
export const INVENTORY_ITEM_TYPE_YARDSIGN_PANEL = 'yardSignPanel';
export const INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_TOP = 'yardSignRiderTop';
export const INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_BOTTOM = 'yardSignRiderBottom';
export const INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_STONE_OAK = 'yardSignRiderStoneOak';
export const INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_3Z = 'yardSignRider3z';
export const INVENTORY_ITEM_TYPE_YARDSIGN_HOMERIVER = 'yardSignHomeRiver';
export const INVENTORY_ITEM_TYPE_MATTERPORT_CAMERA = 'matterportCamera';

// TODO: Handle groups for the following:
export const INVENTORY_ITEM_TYPE_SUNLOCK = 'sunlock';
export const INVENTORY_ITEM_TYPE_YARDSIGN = 'yardSign';

export const INVENTORY_ITEM_TYPES_REGISTERABLE_LIST = [
  INVENTORY_ITEM_TYPE_SUNLOCK,
  INVENTORY_ITEM_TYPE_CODEBOX_SUNROOM,
  INVENTORY_ITEM_TYPE_CODEBOX_HOMERIVER,
  INVENTORY_ITEM_TYPE_COMBO_LOCKBOX,
  INVENTORY_ITEM_TYPE_SUPRA,
  INVENTORY_ITEM_TYPE_YARDSIGN,
  INVENTORY_ITEM_TYPE_YARDSIGN_HOMERIVER,
  INVENTORY_ITEM_TYPE_MATTERPORT_CAMERA,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_TOP,
  INVENTORY_ITEM_TYPE_YARDSIGN_FRAME,
  INVENTORY_ITEM_TYPE_YARDSIGN_PANEL,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_STONE_OAK,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_3Z,
  INVENTORY_ITEM_TYPE_RASPBERRY_PI,
  INVENTORY_ITEM_TYPE_ZTE_STICK,
  INVENTORY_ITEM_TYPE_KWIKSET_LOCK,
];

export const INVENTORY_ITEM_TYPES_OPTIONS = [
  {
    label: 'Codebox (Sunroom)',
    value: INVENTORY_ITEM_TYPE_CODEBOX_SUNROOM,
  },
  {
    label: 'Codebox (HomeRiver)',
    value: INVENTORY_ITEM_TYPE_CODEBOX_HOMERIVER,
  },
  {
    label: 'Combo Lockbox',
    value: INVENTORY_ITEM_TYPE_COMBO_LOCKBOX,
  },
  {
    label: 'Supra',
    value: INVENTORY_ITEM_TYPE_SUPRA,
  },
  {
    label: 'Yard Sign (HomeRiver)',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_HOMERIVER,
  },
  {
    label: 'Yard Sign Rider (Top)',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_TOP,
  },
  {
    label: 'Yard Sign Rider (Bottom)',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_BOTTOM,
  },
  {
    label: 'Yard Sign Frame',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_FRAME,
  },
  {
    label: 'Yard Sign Panel',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_PANEL,
  },
  {
    label: 'Yard Sign Rider (Stone Oak)',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_STONE_OAK,
  },
  {
    label: 'Yard Sign Rider (3Z)',
    value: INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_3Z,
  },
  {
    label: 'Raspberry Pi',
    value: INVENTORY_ITEM_TYPE_RASPBERRY_PI,
  },
  {
    label: 'ZTE Stick',
    value: INVENTORY_ITEM_TYPE_ZTE_STICK,
  },
  {
    label: 'Kwikset Lock',
    value: INVENTORY_ITEM_TYPE_KWIKSET_LOCK,
  },
  {
    label: 'Matterport Camera',
    value: INVENTORY_ITEM_TYPE_MATTERPORT_CAMERA,
  },
];

export const INVENTORY_ITEM_TYPE_TO_LABEL_MAP = INVENTORY_ITEM_TYPES_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.value]: option.label,
  }),
  {},
);

export const INVENTORY_ITEM_TYPES_LIST = [
  INVENTORY_ITEM_TYPE_ZTE_STICK,
  INVENTORY_ITEM_TYPE_RASPBERRY_PI,
  INVENTORY_ITEM_TYPE_KWIKSET_LOCK,
  INVENTORY_ITEM_TYPE_CODEBOX_SUNROOM,
  INVENTORY_ITEM_TYPE_CODEBOX_HOMERIVER,
  INVENTORY_ITEM_TYPE_COMBO_LOCKBOX,
  INVENTORY_ITEM_TYPE_SUPRA,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_TOP,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_BOTTOM,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_STONE_OAK,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_3Z,
  INVENTORY_ITEM_TYPE_YARDSIGN_FRAME,
  INVENTORY_ITEM_TYPE_YARDSIGN_PANEL,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_TOP,
  INVENTORY_ITEM_TYPE_YARDSIGN_RIDER_BOTTOM,
  INVENTORY_ITEM_TYPE_YARDSIGN_HOMERIVER,
  INVENTORY_ITEM_TYPE_MATTERPORT_CAMERA,
  INVENTORY_ITEM_TYPE_SUNLOCK,
  INVENTORY_ITEM_TYPE_YARDSIGN,
];

export const INVENTORY_ITEM_STATUS_OPERATIONAL = 'operational';
export const INVENTORY_ITEM_STATUS_BROKEN = 'broken';
export const INVENTORY_ITEM_STATUS_LOST = 'lost';
export const INVENTORY_ITEM_STATUS_STOLEN = 'stolen';

export const INVENTORY_ITEM_STATUSES_OPTIONS = [
  {
    label: 'Operational',
    value: INVENTORY_ITEM_STATUS_OPERATIONAL,
  },
  {
    label: 'Broken',
    value: INVENTORY_ITEM_STATUS_BROKEN,
  },
  {
    label: 'Lost',
    value: INVENTORY_ITEM_STATUS_LOST,
  },
  {
    label: 'Stolen',
    value: INVENTORY_ITEM_STATUS_STOLEN,
  },
];

export const INVENTORY_ITEM_STATUS_TO_LABEL_MAP = INVENTORY_ITEM_STATUSES_OPTIONS.reduce(
  (acc, option) => ({
    ...acc,
    [option.value]: option.label,
  }),
  {},
);

export const INVENTORY_ITEM_STATUSES_LIST = [
  INVENTORY_ITEM_STATUS_OPERATIONAL,
  INVENTORY_ITEM_STATUS_BROKEN,
  INVENTORY_ITEM_STATUS_LOST,
  INVENTORY_ITEM_STATUS_STOLEN,
];
